import { useQuery } from "@tanstack/react-query";
import PageParams from "../interfaces/pageParams";
import useApiCommunity from "./useApiCommunity";

const usePagedCommunity = (params: PageParams) => {
  const { getPagedCommunity } = useApiCommunity();

  return useQuery({
    queryKey: ["communities", "paged", params],
    queryFn: () => getPagedCommunity({ params: { ...params } }),
    staleTime: 1000 * 60 * 5,
    placeholderData: (previousData) => previousData,
  });
};

export default usePagedCommunity;
